import { useApplicationProcess } from 'src/hooks/useApplicationProcess';

export const useAllQuestions = () => {
  const { loading, error, data: applicationProcess } = useApplicationProcess();
  const questions = applicationProcess?.questionnaire?.questions || [];

  return {
    loading,
    error,
    data: questions,
  };
};
